export const cashFlowOptions = [
  { value: 'Predictable', label: 'Steady and consistent income' },
  { value: 'Unpredictable', label: 'Income may vary' }
];
